"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarTypographyHeader = exports.DrawerServiceNavigation = exports.InnerContainerMainContent = exports.WrapperMainContent = exports.PageLayoutWrapper = void 0;
const tslib_1 = require("tslib");
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Drawer_1 = tslib_1.__importDefault(require("@mui/material/Drawer"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
const InternalConstants = tslib_1.__importStar(require("./InternalConstants"));
exports.PageLayoutWrapper = (0, styles_1.styled)(Box_1.default)(() => ({
    height: `calc(100vh - ${InternalConstants.ARGUS_MENU_HEIGHT}px)`,
    marginTop: `${InternalConstants.ARGUS_MENU_HEIGHT}px`,
    position: "fixed",
    display: "flex",
    width: "100%",
}));
exports.WrapperMainContent = (0, styles_1.styled)("main")({
    overflow: "auto",
    containerType: "inline-size",
});
exports.InnerContainerMainContent = (0, styles_1.styled)("div")(({ theme }) => ({
    padding: theme.spacing(3, 3, 0, 3),
    height: `calc(100vh - ${InternalConstants.ARGUS_MENU_HEIGHT + 64}px)`,
    overflow: "auto",
    ["@container (max-width: 800px)"]: {
        minWidth: "800px",
    },
}));
exports.DrawerServiceNavigation = (0, styles_1.styled)(Drawer_1.default)({
    ".MuiDrawer-paper": {
        marginTop: `${InternalConstants.ARGUS_MENU_HEIGHT}px`,
        width: "300px",
    },
});
exports.SidebarTypographyHeader = (0, styles_1.styled)(Typography_1.default)({ display: "flex", flexGrow: 1 });
